// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[type=range][data-v-61c33a66]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background:#0a9ea5;border-radius:50%;cursor:pointer;height:18px;width:18px}input[type=range][data-v-61c33a66]::-moz-range-thumb{background:#0a9ea5;border:none;border-radius:50%;cursor:pointer;height:18px;width:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
